import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { get } from "../../Services/ApiHandler";
import { BASE_URL, URLS } from "../../Services/Constant";

export default function RazyPay() {
  const [isData, setIsData] = useState({
    key: "",
    show: false,
  });

  const getList = async () => {
    try {
      const res = await get(URLS.RAZYPAYSTATUS);
      console.log("ASDKASKDKASDKKASDKAKDSKA", res);
    } catch (err) {
      console.log("ERROR", err);
    }
  };
  useEffect(() => {
    getList();
  }, []);
  return (
    <div>
      <Topbar header={"Razorypay Key"} />
    </div>
  );
}
